import i18next from "i18next"
import { initReactI18next } from "react-i18next"
import { usePage } from "@inertiajs/react"
import enTranslations from "../locales/en.json"
import idTranslations from "../locales/id.json"

export type Locale = "en" | "id"

const LOCALE_KEY = "locale"

function getSavedLocale(): Locale {
  if (typeof window === "undefined") return "en"
  return (localStorage.getItem(LOCALE_KEY) as Locale) || "en"
}

i18next.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    id: { translation: idTranslations },
  },
  lng: getSavedLocale(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
})

export default i18next

// Sync i18next with Inertia shared locale
export function syncLocaleWithInertia() {
  try {
    // This will only work inside a React component context
    // For usage outside components, use useLocaleSyncer hook instead
    const page = usePage()
    const inertiaLocale = page.props.locale as string || "en"
    if (inertiaLocale && inertiaLocale !== i18next.language) {
      i18next.changeLanguage(inertiaLocale)
      localStorage.setItem(LOCALE_KEY, inertiaLocale)
    }
  } catch (error) {
    // usePage might not be available outside React context
  }
}

// Helper to change locale (mirrors reference app API)
export function setLocale(locale: Locale) {
  i18next.changeLanguage(locale)
  localStorage.setItem(LOCALE_KEY, locale)
}

// Helper to get current locale (mirrors reference app API)
export function getLocale(): Locale {
  return (i18next.language as Locale) || "en"
}

// Simple t() wrapper for use outside React components
export function t(key: string, options?: Record<string, unknown>) {
  return i18next.t(key, options)
}
